import { AuthService } from './../services/auth.service';
import { Observable } from 'rxjs';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | boolean {
    return new Promise((resolve) => {
      this.auth.isLoggedIn().then((data) => {
        if (data) {
          resolve(true);
        } else {
          this.router.navigate(['/login'], { replaceUrl: true });
          resolve(false);
        }
      }, (error) => {
        resolve(false);
      });
    }).catch(() => {
      throw new Error('Promise failure');
    });
  }

}
